import { render, staticRenderFns } from "./DoctorRegisterList.vue?vue&type=template&id=4775bc1b&scoped=true&"
import script from "./DoctorRegisterList.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterList.vue?vue&type=script&lang=js&"
import style0 from "./DoctorRegisterList.vue?vue&type=style&index=0&id=4775bc1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4775bc1b",
  null
  
)

export default component.exports